import { useMainMenuStore } from "~/stores/mainMenu";

export default defineNuxtPlugin(async (nuxtApp) => {
  // Skip plugin when rendering error page
  if (nuxtApp.payload.error) {
    return {};
  }

  const auth = useAuth();
  await auth.fetchUser();

  addRouteMiddleware('auth', (to, _from) => {
    if (to.meta.auth === false) {
      return;
    }

    if (!auth.loggedIn.value) {
      auth.store.setAuthRedirect(to.fullPath);
      return '/login/';
    }

    if (to.meta.defender && !auth.user.value?.is_defender) {
      return auth.user.value?.is_attacker ? '/search/' : '/';
    }
  }, {
    global: true,
  });

  if (import.meta.client) {
    // Redirect to login
    const route = useRoute();
    watch(auth.loggedIn, async (loggedIn) => {
      if (!loggedIn && route.meta.auth !== false) {
        auth.store.setAuthRedirect(route.fullPath);
        await navigateTo('/login/');
      }
    });

    // Clear data stores on logout
    const mainMenuStore = useMainMenuStore();
    const leakprofileAccountStore = useLeakprofileAccountStore();
    watch(auth.loggedIn, () => {
      mainMenuStore.$reset();
      leakprofileAccountStore.$reset();
    });
  }

  return {
    provide: {
      auth
    },
  };
});
